import React, { useState } from 'react';
import { aiApi, brokerApi } from './api';

export default function PortfolioAnalysis() {
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAnalysis = async () => {
    setLoading(true);
    setError(null);
    try {
      const [positions, account] = await Promise.all([brokerApi.positions(), brokerApi.account()]);
      const holdings = Object.fromEntries(positions.map((p) => [p.symbol, Number(p.qty)]));
      const data = await aiApi.portfolioAnalysis({ holdings, cashPosition: Number(account.cash) });
      setAnalysis(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="module-container">
      <div className="module-header">
        <h2>Portfolio Analysis</h2>
        <p>AI assessment of your real, currently-held positions and rebalancing ideas.</p>
      </div>

      <div className="module-content">
        <button onClick={fetchAnalysis} disabled={loading} className="primary-button">
          {loading ? 'Analyzing…' : 'Analyze Portfolio'}
        </button>

        {error && <div className="error-box">{error}</div>}

        {analysis && (
          <div className="analysis-result">
            <div className="analysis-grid">
              <div className="analysis-card score">
                <div className="card-label">Overall Score</div>
                <div className="card-value">{analysis.overallScore}</div>
                <div className="card-unit">/100</div>
              </div>
              <div className="analysis-card diversification">
                <div className="card-label">Diversification</div>
                <div className="card-value">{analysis.diversification}</div>
              </div>
            </div>

            <div className="analysis-sections">
              {analysis.recommendations && (
                <section className="analysis-section">
                  <h3>Recommendations</h3>
                  <ul className="recommendation-list">
                    {analysis.recommendations.map((rec, idx) => (
                      <li key={idx}><span className="icon">→</span>{rec}</li>
                    ))}
                  </ul>
                </section>
              )}

              <div className="two-column">
                {analysis.risks && (
                  <section className="analysis-section">
                    <h3>Identified Risks</h3>
                    <ul className="risk-list">
                      {analysis.risks.map((risk, idx) => (
                        <li key={idx}><span className="icon">!</span>{risk}</li>
                      ))}
                    </ul>
                  </section>
                )}

                {analysis.opportunities && (
                  <section className="analysis-section">
                    <h3>Opportunities</h3>
                    <ul className="opportunity-list">
                      {analysis.opportunities.map((opp, idx) => (
                        <li key={idx}><span className="icon">→</span>{opp}</li>
                      ))}
                    </ul>
                  </section>
                )}
              </div>

              {analysis.rebalanceActions && (
                <section className="analysis-section">
                  <h3>Rebalance Actions</h3>
                  <ul>
                    {analysis.rebalanceActions.map((action, idx) => (
                      <li key={idx}>{action}</li>
                    ))}
                  </ul>
                </section>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
